export var TenantType;
(function (TenantType) {
    TenantType["ChwConnect"] = "CHW_CONNECT";
    TenantType["Host"] = "HOST";
    TenantType["OpenAccess"] = "OPEN_ACCESS";
    TenantType["WhiteLabel"] = "WHITE_LABEL";
    TenantType["WhiteLabelTemplate"] = "WHITE_LABEL_TEMPLATE";
    TenantType["FundaApp"] = "FUNDA_APP";
})(TenantType || (TenantType = {}));
//# sourceMappingURL=tenant.js.map